var _style, _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWow01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 187.8 187.8",
    style: {
      enableBackground: "new 0 0 187.8 187.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:url(#SVGID_00000079447855301268305880000005401735338736616883_);}\r\n\t.st3{fill:url(#SVGID_00000048495644458235961160000015082692662271192192_);}\r\n\t.st4{fill:url(#SVGID_00000174573225116346424300000003899985070981534094_);}\r\n\t\r\n\t\t.st5{clip-path:url(#XMLID_00000165929726969970561140000013710206761892130967_);fill:url(#SVGID_00000059309044381784905130000016706903138811433375_);}\r\n\t.st6{fill:url(#SVGID_00000033346496072166706750000008498368531910035588_);}\r\n\t.st7{fill:url(#SVGID_00000018218675104670795190000002323738511544523403_);}\r\n\t.st8{fill:url(#SVGID_00000170959057055165745330000017215058694093399226_);}\r\n\t.st9{fill:url(#SVGID_00000145054206095616605130000005236534069486886566_);}\r\n\t.st10{fill:url(#SVGID_00000113332990959844736660000010572280375452193434_);}\r\n\t.st11{fill:#DA8421;}\r\n\t.st12{fill:url(#SVGID_00000127045590542023641420000012180934833724054683_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 90.0573,
    cy: 50.6394,
    r: 143.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFED74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4348,
    style: {
      stopColor: "#FAC558"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    style: {
      stopColor: "#F7AB47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6A240"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 94.6,
    cy: 94.9,
    r: 90.1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000047046068417639911150000003273527033320688831_",
    cx: 95.9523,
    cy: 91.6876,
    r: 53.6931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#361D19"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2983,
    style: {
      stopColor: "#3B2018"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6277,
    style: {
      stopColor: "#482916"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.971,
    style: {
      stopColor: "#5E3813"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#603913"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000047046068417639911150000003273527033320688831_)"
    },
    cx: 97.4,
    cy: 109.5,
    rx: 27.9,
    ry: 36.2
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000149365475071822788640000007889097310863290035_",
    cx: 119.2563,
    cy: 37.8082,
    r: 32.5404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F3E3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#333132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#272425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000149365475071822788640000007889097310863290035_)"
    },
    cx: 134.9,
    cy: 49.1,
    rx: 14.1,
    ry: 19.4
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M147.1,25c-1.8,0-3.5-1-4.2-2.8c-1.8-4.3-4.9-7-8.1-7c-3,0-6.1,2.5-7.9,6.5c-1,2.3-3.7,3.3-6,2.3 c-2.3-1-3.3-3.7-2.3-6c3.3-7.3,9.5-11.9,16.1-11.9c6.9,0,13.2,4.8,16.4,12.5c1,2.3-0.1,5-2.4,5.9C148.3,24.9,147.7,25,147.1,25z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M70.2,25c-1.8,0-3.5-1-4.2-2.8c-1.8-4.3-4.9-7-8-7c-3,0-6.1,2.5-7.9,6.5c-1,2.3-3.7,3.3-6,2.3 c-2.3-1-3.3-3.7-2.3-6C45.1,10.8,51.3,6.2,58,6.2c6.9,0,13.2,4.8,16.4,12.5c1,2.3-0.1,5-2.4,5.9C71.4,24.9,70.8,25,70.2,25z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000076590470311015410410000007704037677064681380_",
    cx: 42.4833,
    cy: 37.8082,
    r: 32.5404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3F3E3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2605,
    style: {
      stopColor: "#333132"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6483,
    style: {
      stopColor: "#272425"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000076590470311015410410000007704037677064681380_)"
    },
    cx: 58.1,
    cy: 49.1,
    rx: 14.1,
    ry: 19.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWow01);
export default __webpack_public_path__ + "static/media/wow-01.e47a23129fd899a9d5e0f8483ecea8f8.svg";
export { ForwardRef as ReactComponent };